export default __webpack_public_path__ + "static/media/Jack Guit_1.986d941b.wav";